import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/fund/bill-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-6baa5cd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bill-list" }
const _hoisted_2 = {
  key: 0,
  class: "tabs-content"
}
const _hoisted_3 = { class: "demo-tabs" }
const _hoisted_4 = {
  key: 0,
  class: "dot-notissub"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_7 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_8 = { class: "bill-list-top" }
const _hoisted_9 = {
  key: 0,
  class: "subaccount-fund-country"
}
const _hoisted_10 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_11 = {
  key: 0,
  class: "dot"
}
const _hoisted_12 = { class: "bill-title" }
const _hoisted_13 = { class: "bill-amount" }
const _hoisted_14 = { class: "fund-amount-item" }
const _hoisted_15 = { class: "fund-amount-left" }
const _hoisted_16 = { class: "text" }
const _hoisted_17 = { class: "number" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fund-amount-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    referrerPolicy: "no-referrer",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_19 = { class: "bill-tab" }
const _hoisted_20 = { class: "bill-table" }
const _hoisted_21 = ["src"]
const _hoisted_22 = ["src"]
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "bill-table-time" }
const _hoisted_25 = { class: "bill-table-name" }
const _hoisted_26 = { class: "title" }
const _hoisted_27 = { class: "content" }
const _hoisted_28 = { class: "bill-table-name" }
const _hoisted_29 = { class: "title" }
const _hoisted_30 = { class: "tip" }
const _hoisted_31 = {
  key: 3,
  class: "bill-table-name"
}
const _hoisted_32 = { class: "title" }
const _hoisted_33 = { class: "text" }
const _hoisted_34 = { class: "bill-table-name fee-type-class" }
const _hoisted_35 = { class: "title" }
const _hoisted_36 = {
  key: 0,
  class: "look-more-detail"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode("...")
const _hoisted_38 = { class: "blur" }
const _hoisted_39 = { style: {"max-height":"200px","overflow-y":"auto"} }
const _hoisted_40 = {
  key: 4,
  class: "bill-table-name"
}
const _hoisted_41 = { class: "title" }
const _hoisted_42 = {
  class: "text",
  style: {"height":"70px"}
}
const _hoisted_43 = {
  class: "abs",
  style: {"bottom":"30px","left":"20px","width":"360px"}
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bill-table-line" }, null, -1))
const _hoisted_45 = { class: "bill-table-money" }
const _hoisted_46 = {
  key: 0,
  class: "bill-table-time-set"
}
const _hoisted_47 = {
  key: 1,
  class: "bill-table-btn"
}
const _hoisted_48 = { class: "pagination-content" }
const _hoisted_49 = { class: "pagination" }

import { ref, computed, watch, nextTick, Ref, onMounted } from 'vue'
import { t, lang } from '@/plugins/i18n'
import { formatPrice } from './data'
import { getBillListApi, payBillApi, getBillAmountApi } from '@/apis/fund'
import { useStore } from 'vuex'
import TimeOut from './TimeOut.vue'
import RefuseDialog from './RefuseDialog.vue'
import PayDialog from './PayDialog.vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import { useRoute, useRouter } from 'vue-router'
import { useRtfix, isKO, useSite, isMultiStore } from '@/store'
import { getJapanTime } from '@/util/common'
import SelectIcon from '@/views/usercenter/ProductList/components/SelectIcon.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const store = useStore()
const shopId = store.getters['route/getShopId'] || store.getters.curShop
const isSub = store.getters.isSub
const tab = ref(route.query.type === '2' ? '2' : '1')

if (!route.query.type) {
  history.replaceState(null, '', route.path + '?type=' + tab.value)
}
const loginFund = computed(() => {
  return t('主账户账单')
})

const customerShopName = store.getters.shopname
const customerFund = computed(() => {
  return t('子账户账号') + '(' + customerShopName + ')'
})
const loading = ref(false)
const refuseDialog = ref()
const payDialog = ref()
const totalAmount = ref(0)

const FundCountry = [
  { value: 'CNY', label: t('人民币账单'), logo: 'https://static-s.theckb.com/BusinessMarket/Client/country/ChinaSquareIcon@3x.png' },
  { value: 'KRW', label: t('韩元账单'), logo: 'https://static-s.theckb.com/BusinessMarket/Client/country/KoreaSquareIcon@3x.png' }
]
// 选择国家钱包
const currencyCode: Ref<'CNY'| 'KRW'> = ref('CNY')
// 是否展示小红点
const isShowDot = computed(() => {
  return isMultiStore() && store.getters['bill/getBillNum'] > 0
})
watch(
  route,
  (v) => {
    const query = { ...v.query }
    if (!isMultiStore()) {
      currencyCode.value = 'CNY'
      return
    }
    // 做个兼容，只有为KRW展示韩元，否则字母拼错之类的一律默认CNY
    currencyCode.value = query.currencyCode === 'KRW' ? 'KRW' : 'CNY'
  },
  { immediate: true }
)

const params = ref({
  pageSize: 20,
  pageNum: 1,
  billPayStatus: 2,
  mainOrSubBill: tab.value === '1',
  currencyCode: currencyCode.value
})
if (route.query.id) {
  // 资金明细跳转
  params.value.billPayStatus = Number(route.query.billPayStatus)
  params.value.customerBillId = route.query.id
}
const getLabel = () => {
  const selectInfo = FundCountry.find((item) => item.value === currencyCode.value)
  return selectInfo?.label
}
// 改变钱包
const changeFundCountry = (val:'CNY'| 'KRW') => {
  currencyCode.value = val
  const query = {
    ...route.query,
    currencyCode: val,
    // 当切换币种的时候将customerBillId清空
    id: undefined
  }
  router.replace({ ...route, query })
  params.value.customerBillId  = undefined
  getList()
  getPayAmount()
}

const total = ref(0)
const billList = ref([])
const getList = () => {
  if (!shopId) {
    return
  }
  loading.value = true
  getBillListApi({ ...params.value, currencyCode: currencyCode.value }).then((res: any) => {
    loading.value = false
    if (res.success) {
      billList.value = res.data.records
      total.value = res.data.total
    }
  })
}
const getPayAmount = () => {
  if (!shopId) {
    return
  }
  getBillAmountApi({
    mainOrSubBill: tab.value === '1',
    currencyCode: currencyCode.value
  }).then((res: any) => {
    if (res.success) {
      totalAmount.value = res.data
    }
  })
}
getList()
getPayAmount()
store.dispatch('bill/getBillNum')
const changeTab = (tab: any) => {
  if (params.value.billPayStatus === tab) return
  delete params.value.customerBillId
  params.value.billPayStatus = tab
  getList()
  store.dispatch('bill/getBillNum')
  getPayAmount()
}
const handleSizeChange = (e: any) => {
  params.value.pageSize = e
  params.value.pageNum = 1
  getList()
}
const handleCurrentChange = (e: any) => {
  params.value.pageNum = e
  getList()
}
const pay = (item: any) => {
  payDialog.value.open(item)
}
const paySubmit = (record: any) => {
  payBillApi({
    customerBillId: record.customerBillId,
    mainOrSubBill: tab.value === '1'
  }).then((res: any) => {
    if (res.success) {
      store.dispatch('bill/getBillNum')
      ElMessage.success(t('支付成功'))
      getList()
      getPayAmount()
    }
  })
}
const refuse = (item: any) => {
  refuseDialog.value.open(item)
}
const refuseSubmit = () => {
  getList()
  getPayAmount()
  store.dispatch('bill/getBillNum')
}

const handleTab = (status: string) => {
  router.push(useRtfix('BillList', { query: { type: status, currencyCode: currencyCode.value } }))
  tab.value = status
  params.value = {
    pageSize: 20,
    pageNum: 1,
    billPayStatus: 2,
    mainOrSubBill: status === '1'
  }
  getList()
  getPayAmount()
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isSub))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => {tab.value = '1'; handleTab('1')}),
              class: _normalizeClass(`tabs-default tabs-position-relative ${tab.value === '1'?'tabs-active':''}`)
            }, [
              (_unref(isShowDot))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : _createCommentVNode("", true),
              (!_unref(isMultiStore)())
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(loginFund)), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", null, _toDisplayString(getLabel()), 1),
                    _createVNode(_component_el_select, {
                      size: "small",
                      style: {"width":"30px"},
                      class: "select-no-border-special-nolabel",
                      "popper-class": `select-no-border-special-popper-nolabel-bill${_unref(lang)}`,
                      "model-value": currencyCode.value,
                      onChange: changeFundCountry,
                      "suffix-icon": SelectIcon
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(FundCountry, (country) => {
                          return _createVNode(_component_el_option, {
                            size: "small",
                            key: country.value,
                            label: country.label,
                            value: country.value
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("span", null, _toDisplayString(country.label), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["popper-class", "model-value"])
                  ]))
            ], 2),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => {tab.value = '2';handleTab('2')}),
              class: _normalizeClass(`tabs-default ${tab.value === '2'?'tabs-active':''}`)
            }, _toDisplayString(_unref(customerFund)), 3)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      (_unref(isSub) && _unref(isMultiStore)())
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_el_select, {
              size: "small",
              style: {"width":"200px","margin-bottom":"24px"},
              class: "select-no-border-special",
              "popper-class": "select-no-border-special-popper",
              "model-value": currencyCode.value,
              onChange: changeFundCountry,
              "suffix-icon": SelectIcon
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(FundCountry, (country) => {
                  return _createVNode(_component_el_option, {
                    size: "small",
                    key: country.value,
                    label: country.label,
                    value: country.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", null, _toDisplayString(country.label), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["model-value"]),
            (_unref(isShowDot))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('我的账单')), 1),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('待支付总额')) + "(" + _toDisplayString(currencyCode.value === 'KRW' ? _unref(t)("KRW") : _unref(t)('元')) + ")", 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(formatPrice)(totalAmount.value)), 1)
          ]),
          _hoisted_18
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", {
        class: _normalizeClass([{ active: params.value.billPayStatus === 2 }, 'bill-tab-item']),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (changeTab(2)))
      }, _toDisplayString(_unref(t)('待支付')), 3),
      _createElementVNode("div", {
        class: _normalizeClass([{ active: params.value.billPayStatus === 1 }, 'bill-tab-item']),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (changeTab(1)))
      }, _toDisplayString(_unref(t)('已完成')), 3),
      _createElementVNode("div", {
        class: _normalizeClass([{ active: params.value.billPayStatus === 4 }, 'bill-tab-item']),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (changeTab(4)))
      }, _toDisplayString(_unref(t)('已拒绝2')), 3),
      _createElementVNode("div", {
        class: _normalizeClass([{ active: params.value.billPayStatus === 3 }, 'bill-tab-item']),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (changeTab(3)))
      }, _toDisplayString(_unref(t)('已取消2')), 3)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", null, [
        (billList.value.length === 0 && !loading.value)
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              class: "ShopWindow-goods-empty",
              description: _unref(t)('没有更多了')
            }, null, 8, ["description"]))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(billList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([{ cancel: params.value.billPayStatus === 3, finish: params.value.billPayStatus === 1, wait: params.value.billPayStatus === 2,refuse: params.value.billPayStatus === 4 }, 'bill-table-item']),
          key: index
        }, [
          (params.value.billPayStatus === 1)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                referrerPolicy: "no-referrer",
                src: `https://static-s.theckb.com/BusinessMarket/Client/fund/bill-finish-${_unref(useSite)()}.png`,
                alt: "",
                class: "seal"
              }, null, 8, _hoisted_21))
            : _createCommentVNode("", true),
          (params.value.billPayStatus === 3)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                referrerPolicy: "no-referrer",
                src: `https://static-s.theckb.com/BusinessMarket/Client/fund/bill-cancel-${_unref(useSite)()}.png`,
                alt: "",
                class: "seal"
              }, null, 8, _hoisted_22))
            : _createCommentVNode("", true),
          (params.value.billPayStatus === 4)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                referrerPolicy: "no-referrer",
                src: `https://static-s.theckb.com/BusinessMarket/Client/fund/bill-refuse-${_unref(useSite)()}.png`,
                alt: "",
                class: "seal"
              }, null, 8, _hoisted_23))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(getJapanTime)(item.billTime)), 1),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)('账单名称')), 1),
            _createElementVNode("div", _hoisted_27, _toDisplayString(item.billName), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)('扣款说明')), 1),
            _createElementVNode("div", _hoisted_30, _toDisplayString(item.billIntroduceJa), 1)
          ]),
          (params.value.billPayStatus === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)('流水号')), 1),
                _createElementVNode("div", _hoisted_33, _toDisplayString(item.payFlowNu), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(t)('费用说明')), 1),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fundTypeRelationList?.slice(0,2), (item1) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "fee-type-row",
                  key: item1.fundFlowType
                }, _toDisplayString(item1.fundFlowName) + " " + _toDisplayString(item1.subTypeName ? '-' + item1.subTypeName:'') + " " + _toDisplayString(item1.proportionAmount) + _toDisplayString(currencyCode.value === 'KRW' ? _unref(t)("韩元") : _unref(t)('元')), 1))
              }), 128)),
              _createVNode(_component_el_popover, {
                placement: "top-start",
                width: 450,
                trigger: "click",
                "popper-class": "fundlist-fee-instructions-popover"
              }, {
                reference: _withCtx(() => [
                  (item.fundTypeRelationList?.length > 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(t)('详情')) + ">", 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_39, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fundTypeRelationList, (item1) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "fee-type-row",
                        key: item1.fundFlowType
                      }, _toDisplayString(item1.fundFlowName) + " " + _toDisplayString(item1.subTypeName ? '-' + item1.subTypeName:'') + " " + _toDisplayString(item1.proportionAmount) + _toDisplayString(currencyCode.value === 'KRW' ? _unref(t)("韩元") : _unref(t)('元')), 1))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          (params.value.billPayStatus === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(t)('拒绝原因2')), 1),
                _createElementVNode("div", _hoisted_42, _toDisplayString(item.customerRefusedReason), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(t)('应付总额')) + " " + _toDisplayString(currencyCode.value === 'KRW'? '₩':'¥') + _toDisplayString(_unref(formatPrice)(item.billAmount)), 1),
            (params.value.billPayStatus === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createVNode(TimeOut, {
                    time: item.residualPayTime,
                    onOut: refuseSubmit
                  }, null, 8, ["time"])
                ]))
              : _createCommentVNode("", true),
            (params.value.billPayStatus === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    class: "pay",
                    onClick: ($event: any) => (pay(item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('立即支付2')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_button, {
                    class: "refuse",
                    onClick: ($event: any) => (refuse(item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('拒绝')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2))
      }), 128))
    ], 512), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("div", _hoisted_49, [
        _createVNode(_component_el_pagination, {
          currentPage: params.value.pageNum,
          "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((params.value.pageNum) = $event)),
          "page-size": params.value.pageSize,
          "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((params.value.pageSize) = $event)),
          background: true,
          layout: "prev, pager, next, sizes,total, jumper",
          "page-sizes": [20, 40, 60, 80],
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["currentPage", "page-size", "total"])
      ])
    ]),
    _createVNode(RefuseDialog, {
      ref: (_value, _refs) => {
        _refs['refuseDialog'] = _value
        refuseDialog.value = _value
      },
      onSubmit: refuseSubmit,
      type: tab.value
    }, null, 8, ["type"]),
    _createVNode(PayDialog, {
      ref: (_value, _refs) => {
        _refs['payDialog'] = _value
        payDialog.value = _value
      },
      onSubmit: paySubmit
    }, null, 512)
  ]))
}
}

})